import styled from 'styled-components'
import { colors } from '../../../../../styles/constants'

export const Container = styled.div`
  display: flex;
  min-width: 337px;
  border-radius: 16px;
  padding: 16px;
  align-items: center;
  align-self: stretch;
  background-color: #F8F9FA;
`
export const WrapperUserData = styled.div`
  display: flex;
  gap: 16px;
`
export const WrapperText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`
export const DoctorName = styled.p`
  min-width: 277px;
  color: ${colors.gray.darker};
  font-family: Open Sans;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 19.2px;
  margin: 0;
`
export const DoctorCnpj = styled.p`
  color: ${colors.gray.darker};
  font-family: Open Sans;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin: 0;
`
